import { apiClient } from "@/api/client";
import type { IBill } from "@/api/restaurant/purchases";
import { API_ENDPOINTS } from "@/config/app";
import type { PaginationParams } from "@/types/api";
import { withAdminCurrency } from "@/utils/adminCurrency";
import { buildUrl } from "@/utils/buildUrl";

import type { AdminTransactionResponse, PosSettlementsResponse } from "./types";

export const transactionsAdminApi = {
  async getAllAdminTransactions(
    params?: PaginationParams
  ): Promise<AdminTransactionResponse> {
    const url = buildUrl(
      API_ENDPOINTS.ADMIN,
      "/transactions/transactions",
      withAdminCurrency(params)
    );

    const response = await apiClient.get<AdminTransactionResponse>(url);
    return response;
  },

  async exportCSVAdminTransactions(
    params?: PaginationParams
  ): Promise<{ blob: Blob; filename: string }> {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = buildUrl(
      API_ENDPOINTS.ADMIN,
      "/transactions/transactions/export-csv",
      withAdminCurrency(params)
    );
    return await apiClient.download(`${url}&timezone=${timeZone}`, {
      method: "GET",
    });
  },

  async getTransactionsDetailsById(id: string): Promise<IBill> {
    const response = await apiClient.get<IBill>(
      `${API_ENDPOINTS.ADMIN}/transactions/transactions/${id}`
    );
    return response;
  },

  async getPosSettlementsById(id: string): Promise<PosSettlementsResponse> {
    const response = await apiClient.get<PosSettlementsResponse>(
      `${API_ENDPOINTS.ADMIN}/transactions/settlements/${id}`
    );
    return response;
  },
};
